import MobileColumnLeft from './components/Left';
import MobileColumnRight from './components/Right';

const TransactionsMobileColumn = {
	Left: MobileColumnLeft,
	Right: MobileColumnRight,
};

export default TransactionsMobileColumn;
